import {NotificationProvider} from '@refinedev/core';
import {toast} from 'react-toastify';
import ToastMessage from '@/components/basic/ToastMessage';

const notificationProvider: NotificationProvider = {
  open: ({key, message, description, type}) => {
    // Implement your notification logic here
    console.log(`Notification: ${type} - ${message}: ${description}`);
    toast(<ToastMessage key={key} message={message} type={type} details={description} />, {
      autoClose: 2000,
    });
  },
  close: key => {
    // Implement your close notification logic here
    console.log(`Close notification: ${key}`);
    toast.dismiss(key);
  },
};

export default notificationProvider;
